<!-- 


    -------------------------------------------------

    DEPRECATED - DO NOT USE FOR NEW DEVELOPMENT

    > Replaced by UIStamp

    -------------------------------------------------
    

    
-->
<template>
    <div class="status"
        :class="{
            'status--on': isOn
        }"
    >
        {{$t(statusText)}}
    </div>
</template>

<script>

export default {
    props: {
        // size properties
        isOn: {
            type: Boolean,
            required: true
        },
        onText: {
            type: String,
            default: 'ON'
        },
        offText: {
            type: String,
            default: 'OFF'
        }
    },
    data () {
        return {};
    },
    computed: {
        statusText() {
            return this.isOn ? this.onText : this.offText;
        }
    }

};
</script>